import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';

const STATUS_COLORS = {
  requested: '#F97316',
  planning: '#9CA3AF',
  in_progress: '#3B82F6',
  scheduled: '#3B82F6',
  completed: '#C8E600',
  completed_invoiced: '#10B981',
  cancelled: '#EF4444',
  on_hold: '#9CA3AF',
  pending: '#F59E0B',
};

const CustomChartTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0];
  return (
    <div className="bg-white border border-border rounded-lg shadow-lg px-3 py-2 text-sm">
      <p className="font-medium">{p.name}: {p.value}</p>
    </div>
  );
};

export const ProjectStatusPieChart = ({ statusBreakdown = {}, onSliceClick, testId = 'chart-status' }) => {
  const statusPieData = Object.entries(statusBreakdown).map(([status, count]) => ({
    name: status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    value: count,
    status,
  }));

  return (
    <Card data-testid={testId} className="shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="font-heading text-base">Project Status Distribution</CardTitle>
        <CardDescription className="text-xs">Click a slice to view project details</CardDescription>
      </CardHeader>
      <CardContent>
        {statusPieData.length > 0 ? (
          <div className="flex items-center gap-4">
            <ResponsiveContainer width="55%" height={180}>
              <PieChart>
                <Pie
                  data={statusPieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  dataKey="value"
                  onClick={(d) => onSliceClick && onSliceClick(d.status)}
                  className="cursor-pointer"
                >
                  {statusPieData.map((entry) => (
                    <Cell key={entry.status} fill={STATUS_COLORS[entry.status] || '#9CA3AF'} />
                  ))}
                </Pie>
                <RechartsTooltip content={<CustomChartTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <div className="flex-1 space-y-2">
              {statusPieData.map(entry => (
                <div
                  key={entry.status}
                  className="flex items-center justify-between cursor-pointer group hover:bg-muted/50 rounded px-2 py-1 transition-colors"
                  onClick={() => onSliceClick && onSliceClick(entry.status)}
                >
                  <div className="flex items-center gap-2">
                    <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: STATUS_COLORS[entry.status] || '#9CA3AF' }} />
                    <span className="text-xs font-medium">{entry.name}</span>
                  </div>
                  <span className="text-xs font-bold tabular-nums">{entry.value}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-center text-muted-foreground py-8 text-sm">No data available</p>
        )}
      </CardContent>
    </Card>
  );
};

export default ProjectStatusPieChart;
